<template>
  <div class="create-form">
    <div class="acivity-right">
      <el-form :inline="true" class="acivity-content-form" ref="formInline" :model="formInline" :rules="rules" label-width="110px">
        <el-form-item label="商品名称：" prop="title">
          <el-input v-model="formInline.title" placeholder="请输入商品名称（不能超过20字）" maxlength="20" class="inputwidth"></el-input>
        </el-form-item>
        <el-form-item label="兑换时间：" prop="date">
          <el-date-picker v-model="formInline.date" @change="dateChange" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
          <br/>
          <el-checkbox v-model="show_djs">显示倒计时</el-checkbox>
        </el-form-item>
        <el-form-item label="类型：" prop="type">
          <el-select v-model="formInline.type" placeholder="请选择类型" >
            <el-option v-for="item in typeOptions"
                 :key="item.value"
                 :label="item.label"
                 :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消耗积分：">
          <el-input v-model="formInline.score" placeholder="请填写消耗积分，0代表不消耗积分" type="number" min="0" style="width: 190px;"></el-input> 分
        </el-form-item>
        <el-form-item label="消耗现金：" prop="money">
          <el-input v-model="formInline.money"  placeholder="请填写消耗现金，0代表全积分兑换" type="number" min="0" style="width: 190px;"></el-input> 元
        </el-form-item>
        <el-form-item label="可兑换数量：" prop="total">
          <el-input v-model="formInline.total" placeholder="该商品总共可被兑换的数量" type="number" min="0" style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item label="兑换规则：">
          <el-select v-model="formInline.rules" placeholder="请选择">
            <el-option v-for="item in ruleOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          可兑换
          <el-input v-model="formInline.times" placeholder="0代表不限制" type="number" min="0" style="width: 120px;"></el-input>次
        </el-form-item>
        <el-form-item label="兑换范围：">
          <el-select filterable multiple v-model="selectGradelist" placeholder="请选择">
            <el-option v-for="item in gradelists"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品主图：" >
          <el-upload class="avatar-uploader" style="width: 400px;" name="file_upload" :action="uploadURL" :show-file-list="false" :on-success="(res, file) => { return handleInterfaceSuccess(res, file, 'logo')}" :before-upload="beforeAvatarUpload">
            <img v-if="formInline.logo" :src="formInline.logo" style="width: 178px; height: 178px; display: block;">
            <i v-else class="el-icon-plus avatar-uploader-icon" @click="handleRemove('logo')"></i>
          </el-upload>
          <p class="interface_update_p" style="width: 400px;">建议尺寸375px*375px，大小200kb以内，格式为jpg,png
          </p>
        </el-form-item>
        <el-form-item label="商品描述：">
          <el-input type="textarea" style="width: 370px;" :autosize="{ minRows: 2, maxRows: 10}" placeholder="请输入内容" v-model="formInline.content" maxlength="40000">
          </el-input>
        </el-form-item>
        <el-form-item label="排序：">
          <el-input v-model="formInline.sort" placeholder="请填写排序" type="number" min="0"></el-input>
        </el-form-item>
      </el-form>
      <div style="width:190px;margin: 0 0 20px 40%;" class="interface_btn">
        <el-button class="dialog-confirm-btn" style="margin-left: 10px" type="primary" @click="editInterests()">保存</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { API_HOST, API_HOST_JAVA_SET } from '@/api/local'
import { editYzIntegralSet, getYzGrade, getYzIntegralSetDetail } from '@/api/applet.js'
export default {
  name: 'add-interest',
  data() {
    return {
      id: 0,
      gradelists: [],
      selectGradelist: [],
      show_djs: false,
      typeOptions: [
        {
          value: 1,
          label: '实物商品'
        },
        {
          value: 2,
          label: '虚拟商品'
        }
      ],
      ruleOptions:[
        {
          value: 1,
          label: '活动期间'
        },
        {
          value: 2,
          label: '每日'
        },
        {
          value: 3,
          label: '每周'
        },
        {
          value: 4,
          label: '每月'
        },
      ],
      formInline: {
        title: '',
        date: [],
        start: '',
        end: '',
        type: 1,
        score: null,
        money: null,
        total: null,
        grade_list: '',
        logo: '',
        content: '',
        rules: 1,
        times: 0,
        sort: 0,
      },
      rules: {
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        date: [
          { required: true, message: '请选择活动时间', trigger: 'blur' }
        ],
        total: [
          { required: true, message: '请输入可兑换数量', trigger: 'blur' }
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000
        }
      },
      pickerAppointedOptions: {
        disabledDate: (time) => {
          let _this = this
          let start = new Date(Date.parse(_this.formInline.start.replace(/-/g, '/')))
          let end = new Date(Date.parse(_this.formInline.end.replace(/-/g, '/')))
          return !((time.getTime() >= start) && (time.getTime() <= end))
        }
      },
    }
  },
  methods: {
    editInterests() {
      this.formInline.show_djs = this.show_djs ? 1 : 0
      this.formInline.grade_list = this.selectGradelist.toString()
      editYzIntegralSet(this.id,this.formInline).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          router.push('/home/yzintegralset')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    dateChange(value) {
      if (value) {
        this.formInline.start = value[0]
        this.formInline.end = value[1]
      } else {
        this.formInline.start = ''
        this.formInline.end = ''
      }
    },
    // 获取等级列表
    getGradeList() {
      getYzGrade().then((res) => {
        if(res.data.code == 0) {
          for (let item of res.data.data.list) {
            this.gradelists.push({
              label: item.level_title,
              value: item.level,
            })
          }
          console.log(this.gradelists)
        }
        else{
          console.log(res.data.error)
        }
        this.getData()
      })
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isPNG) {
        _g.toastMsg('error', '上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        _g.toastMsg('error', '上传活动图片大小不能超过 1MB!')
      }
      const check = (isJPG && isLt2M) || (isPNG && isLt2M)
      if (check) {
        _g.toastMsg('success', '正在上传')
      }
      return check
    },
    handleInterfaceSuccess(res, file, index) {
      if (res.code != 0) {
        _g.toastMsg('error', res.error)
      }
      if (index === 'logo') {
        this.formInline.logo = res.data.path
      }
      _g.toastMsg('success', '上传成功')
    },
    getData(){
      getYzIntegralSetDetail(this.id).then(res => {
        this.formInline = JSON.parse(JSON.stringify(res.data.data))
        if(this.formInline.show_djs == 1) {
          this.show_djs = true
        }
        if (this.formInline.grade_list !== '') {
          for (let one of this.formInline.grade_list.split(',')) {
            this.selectGradelist.push(one)
          }
        }
      })
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getGradeList()
  },
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
}

</script>
<style scoped>
.create-form {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: calc(100% - 40px);
  background: #fff;
  margin: 20px auto 0;
  overflow-x: hidden;
}
.acivity-right {
  margin: 20px auto;
  width: 100%;
  align-items: center;
  display: block;
  justify-content: center;
}
.inputwidth{
  width: 370px;
}
.acivity-content-form {
  width: 534px;
  text-align: left;
  margin: auto;
}

.acivity-content-form .el-form-item__content {
  width: 300px;
}

.acivity-content-form p {
  margin: 0px;
  line-height: 20px;
  text-align: left;
  color: #999;
  font-size: 12px;
}
.x_input{
  width:172px!important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
</style>
